<template>
  <div class="bodycontent">
    <div class="options">
      <!-- <div class="options_item">
        <span>类型</span>
        <el-radio-group v-model="params.type" size="small" @change="getData(1)">
          <el-radio-button label="0">全部</el-radio-button>
          <el-radio-button label="1">普通短信</el-radio-button>
          <el-radio-button label="2">营销短信</el-radio-button>
        </el-radio-group>
      </div> -->
      <div class="options_item">
        <span>支付状态</span>
        <el-radio-group v-model="params.pay_status" size="small" @change="getData(1)">
          <el-radio-button label="0">全部</el-radio-button>
          <el-radio-button label="1">未支付</el-radio-button>
          <el-radio-button label="2">已支付</el-radio-button>
        </el-radio-group>
      </div>
      <div class="options_item">
        <span>订单编号</span>
        <el-input size="small" class="input_box" v-model="params.ordersn">
          <el-button slot="append" icon="el-icon-search" @click="getData(1)"></el-button>
        </el-input>
      </div>
    </div>
    <div class="page_form">
      <el-table :header-cell-style="setTableHeader" :data="listData">
        <el-table-column label="订单编号" prop="ordersn"></el-table-column>
        <el-table-column label="类型" prop="show_type"></el-table-column>
        <el-table-column label="单价" prop="price"></el-table-column>
        <el-table-column label="数量" prop="num"></el-table-column>
        <el-table-column label="支付金额" prop="amount"></el-table-column>
        <el-table-column label="支付状态" prop="show_status"></el-table-column>
      </el-table>
    </div>
    <div class="page_bottom">
      <el-pagination
        layout="prev, pager, next, total, jumper"
        :current-page="page"
        :total="total"
        :page-size="10"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { SMSOrderList } from "@/api/set";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      listData: [], // 已选择的模板列表
      page: 1, // 已选择列表分页
      total: 0, // 已选择列表总数
      params: {
        type: 0,
        pay_status: 0,
        ordersn: ""
      }, //查询参数
    };
  },
  mounted(){
    this.getData();
  },
  methods:{
    getData(i){
      if(i == 1) {
        this.page = 1;
      }
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page
      }
      if(this.params.type != 0){
        data.type = this.params.type;
      }
      if(this.params.pay_status != 0){
        data.pay_status = this.params.pay_status
      }
      if(this.params.ordersn != ""){
        data.ordersn = this.params.ordersn
      }
      SMSOrderList(data).then(res => {
        if(res.code == 200){
          this.listData = res.data.data;
          this.total = res.data.total;
          this.listData.forEach(item => {
            item.show_type = item.type == 1? "普通短信":item.type == 2? "营销短信":""
            item.show_status = item.pay_status == 1? "未支付":"已支付"
          })
        }
      })
    },
    handleCurrentChange(val){ 
      this.page = val;
      this.getData();
    }
  }
}
</script>
<style lang="scss" scoped>
.bodycontent{
  .options{
    margin: 10px;
    padding-top: 15px;
    .options_item{
      display: inline-block;
      margin-right: 30px;
      span{
        margin-right: 12px;
      }
    }
  }
  .page_form{
    padding-top: 20px;
    font-size: 14px;
  }
  .page_bottom{
    padding-top: 10px;
  }
  .input_box{
    width: 200px;
  }
}
</style>